var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.message)?_c('div',{staticClass:"error-container"},[_c('div',{staticClass:"error-message"},[_c('span',{staticClass:"error-icon"},[_vm._v("⚠️")]),_vm._v(" "+_vm._s(_vm.message)+" "),_c('button',{staticClass:"error-close",on:{"click":_vm.dismiss}},[_vm._v("×")])])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }